export default "__VITE_ASSET__UTbqz77Q__"